var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reporting-section reporting-overview" }, [
    _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "material-icons section-icon" }, [
        _vm._v("dashboard"),
      ]),
      _c("h2", [_vm._v(_vm._s(_vm.$t("dash.reporting.overview")))]),
      _vm.prevLoading
        ? _c("span", { staticClass: "prev-loading-badge" }, [
            _c("span", { staticClass: "prev-loading-dot" }),
            _vm._v(_vm._s(_vm.$t("dash.reporting.prev_loading")) + "\n    "),
          ])
        : _vm._e(),
    ]),
    _vm.page
      ? _c(
          "div",
          { staticClass: "metric-row" },
          [
            _c("MetricCard", {
              attrs: {
                value: _vm.stats.page.page_fans || 0,
                "previous-value": _vm.prevPeriod
                  ? _vm.prevPeriod.page_fans
                  : null,
                label: _vm.$t("dash.reporting.followers"),
                icon: "group",
              },
            }),
            _c("MetricCard", {
              attrs: {
                value: _vm.stats.page.nb_posts || 0,
                "previous-value": _vm.prevPeriod
                  ? _vm.prevPeriod.nb_posts
                  : null,
                label: _vm.$t("dash.reporting.publications"),
                icon: "edit",
              },
            }),
            _c("MetricCard", {
              attrs: {
                value: _vm.stats.page.totalImpressions || 0,
                "previous-value": _vm.prevPeriod
                  ? _vm.prevPeriod.totalImpressions
                  : null,
                label: _vm.$t("dash.reporting.impression"),
                icon: "visibility",
              },
            }),
            _vm.stats.page.totalUniqueImpressions != null &&
            _vm.network === "linkedin"
              ? _c("MetricCard", {
                  attrs: {
                    value: _vm.stats.page.totalUniqueImpressions || 0,
                    "previous-value": _vm.prevPeriod
                      ? _vm.prevPeriod.totalUniqueImpressions
                      : null,
                    label: _vm.$t("dash.reporting.unique_impression"),
                    icon: "visibility_off",
                  },
                })
              : _vm._e(),
            _c("MetricCard", {
              attrs: {
                value: _vm.stats.page.totalEngagement || 0,
                "previous-value": _vm.prevPeriod
                  ? _vm.prevPeriod.totalEngagement
                  : null,
                label: _vm.$t("dash.reporting.interactions"),
                icon: "fa-solid fa-hand-point-up",
              },
            }),
            _vm.stats.page.totalClicks != null &&
            (_vm.network === "facebook" || _vm.network === "linkedin")
              ? _c("MetricCard", {
                  attrs: {
                    value: _vm.stats.page.totalClicks || 0,
                    "previous-value": _vm.prevPeriod
                      ? _vm.prevPeriod.totalClicks
                      : null,
                    label: _vm.$t("dash.reporting.clic"),
                    icon: "touch_app",
                  },
                })
              : _vm._e(),
            _vm.hasEngagementRate
              ? _c("MetricCard", {
                  attrs: {
                    value: _vm.engagementRate,
                    "previous-value": _vm.prevEngagementRate,
                    label: _vm.$t("dash.reporting.engagement_rate"),
                    icon: "show_chart",
                    format: "percent",
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }